import { T } from "@tolgee/react";

export const ValidationPopupAttentionBadge = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <div
      className={
        "w-fit rounded-[16px] py-0.5 px-2 font-medium text-[10px] text-white bg-red-600"
      }
    >
      <T keyName="please-note" />
    </div>
  );
};
